// extracted by mini-css-extract-plugin
export default {"espacamento":"MultiCombo_espacamento__sUIK8","label":"MultiCombo_label__mDrCo"};